import {db, firestore} from '@/firebase/firebase.js'

const state = {
  selectedProject: {},
  projects: {},
  iconCache: {}
}

const mutations = {
  setProjectsData (state, payload) {
    state.projects = payload
  },
  setSelectedProject (state, payload) {
    state.selectedProject = payload
  },
  addIcon (state, payload) {
    state.iconCache[payload.ref] = payload.icon
  }
}

const actions = {
  fetchIconAddress ({state, commit}, refAddress) {
    if (!state.iconCache.hasOwnProperty(refAddress)) {
      let pathRef = firestore.ref(refAddress)
      pathRef.getDownloadURL().then(function (url) {
        commit('addIcon', {ref: refAddress, icon: url})
      })
    }
  },
  fetchProjects ({commit, state, rootState}) {
    var ref = db.ref('users')
    ref.child(rootState.user.user.id).on('value', function (snapshot) {
      commit('setProjectsData', snapshot.val().projects)
    })
    // ref.orderByChild('uid').equalTo(rootState.user.user.id).on('child_added', function (snapshot) {
    //   commit('setProjectsData', snapshot.val().projects)
    // })
  },
  setProjectData ({commit, state, rootState}, payload) {
    db.ref('projects/' + payload.projectID + '/properties').once('value').then(function (snapshot) {
      commit('setSelectedProject', snapshot.val())
    })
  }
}

const getters = {
  projects (state) {
    return state.projects
  },
  selectedProject (state) {
    return state.selectedProject
  },
  icons (state) {
    return (iconRefAddress) => {
      return state.iconCache[iconRefAddress]
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/project.js